<section *ngIf="loading">
  <div class="row p-2">
      <div class="col-md-12 card card-body">
          <h4 class="h4-responsive text-center" *ngIf="hasAssignment">Loading {{assignmentName}}...</h4>
          <h4 class="h4-responsive text-center" *ngIf="!hasAssignment">Loading your next assignment...</h4>
      </div>
    </div>
    <div class="row p-2 text-center">
      <app-spin-icon class="ml-auto mr-auto" [spinnerType]="big"></app-spin-icon>
    </div>
    <div class="row p-2">
      <div class="col card card-body">
          <div class="row">
            <div class="col-6 col-sm-3 col-md-2 order-1"></div>
            <div class="col-12 col-sm-6 col-md-8 text-center order-3 order-md-2">
              <h4 class="h4-responsive">Loading...</h4>
                Page <span class="badge badge-pill badge-primary">1 </span> of <app-spin-icon></app-spin-icon>
            </div>
            <div class="col-6 col-sm-3 col-md-2 text-right order-2 order-md-3">
              <input disabled="disabled" type="button" class="btn btn-primary" value="Submit" />
            </div>
          </div>
        </div>
      </div>
</section>
<section *ngIf="!loading">
  <div class="row">
      <dac-assessment *ngIf="shouldDisplayAssessment()" class="col" [assessment]="assessment" (onSubmit)="submitAssessment($event)" [disabled]="saving"></dac-assessment>
      <dac-exercise *ngIf="shouldDisplayExercise()" class="col" [exercise]="asset" (onSubmit)="submitAsset($event)" [disabled]="saving"></dac-exercise>
      <dac-article *ngIf="shouldDisplayArticle()" class="col" [article]="asset" (onSubmit)="submitAsset($event)" [disabled]="saving"></dac-article>
  </div>
</section>


// WEBPACK FOOTER //
// ./src/app/assessments/take-assignment/take-assignment.component.html